export enum APPOINTMENT_NOTIFICATION_TYPES {
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
  CANCEL_BY_CUSTOMER = 'CANCEL_BY_CUSTOMER',
  MESSAGE = 'MESSAGE',
}
